import styled from "styled-components";
import { COLORS } from "../../../constants";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../router/routes";
import { CardTitle, Image, Letter, SeparatorLine } from "../../_ui";
import store from "../../../_services/store";

export const SymptomsSectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  flex-wrap: wrap;
  gap: 10px;
`;

export const SymptomCardContainer = styled.div`
  display: flex;
  height: 64px;
  padding: 0px 0px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  background: ${COLORS.WHITE};
  cursor: pointer;
  &:hover {
    box-shadow: rgba(0, 0, 0, 0.5) 0px 0px 6px;
  }
`;

export const ModalTitle = styled.h3`
  color: ${COLORS.DARK};
  text-align: center;
  padding: 0px 16px;
  margin: 0;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: capitalize;
`;

export const ModalContent = styled.div`
  color: ${COLORS.DARK};
  text-align: center;
  padding: 0px 16px;
  /* Paragraph */
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const ModalButton = styled.p<{ $color?: string; }>`
  color: ${props => props.color ? props.color : COLORS.PRIMARY};
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 0;
  margin-bottom: 8px;
  cursor: pointer;
`;

//@ts-ignore
export const SymptomsSection = ({ symptomsSection, setSelectedSymptomDetail }:{symptomsSection, setSelectedSymptomDetail}) => {
  const letter = Object.keys(symptomsSection)[0];
  return (
    <div>
      <Letter>{letter}</Letter>
      <SeparatorLine />
      <SymptomsSectionContainer>
        {symptomsSection[letter].map((e: TMolecule, i: number) => <SymptomCard setSelectedSymptomDetail={setSelectedSymptomDetail} key={`SectionCard_${i}`} symptom={e} />)}
      </SymptomsSectionContainer>
    </div>
  )
}

export const SymptomCard = ({ symptom, setSelectedSymptomDetail }: { symptom: TMolecule, setSelectedSymptomDetail: Function }) => {
  const imgUrl = store.symptomesList.find(e => e.id === symptom.id)?.photo;

  return (
    <SymptomCardContainer onClick={() => setSelectedSymptomDetail(+symptom.id)}>
      {imgUrl && <Image src={imgUrl} width='64px' height='64px' style={{ borderRadius: '20px 0px 0px 20px' }} />}
      <CardTitle style={{ marginInline: '10px' }}>{symptom.title}</CardTitle>
    </SymptomCardContainer>
  )
}